import { useLocalStorage } from '@vueuse/core'
import { LAST_THIRD_TOKEN } from '~/constants'

export function useLastThirdToken(zoneCode: string) {
  return useLocalStorage(`${LAST_THIRD_TOKEN}-${zoneCode}`, '')
}
